export const InvestmentObjective = Object.freeze({
    ASSET_GENERATION: 'ASSET_GENERATION',
    RETIREMENT: 'RETIREMENT',
    REAL_ESTATE: 'REAL_ESTATE',
    EXPENSES: 'EXPENSES',
});

export const InvestmentRegion = Object.freeze({
    SWITZERLAND: 'SWITZERLAND',
    WORLD: 'WORLD',
});

export const InvestmentStrategyType = Object.freeze({
    INCOME: {
        name: 'INCOME',
        risk: 1,
    },
    CONSERVATIVE: {
        name: 'CONSERVATIVE',
        risk: 2,
    },
    BALANCED: {
        name: 'BALANCED',
        risk: 3,
    },
    GROWTH: {
        name: 'GROWTH',
        risk: 4,
    },
    DYNAMIC: {
        name: 'DYNAMIC',
        risk: 5,
    },
});

export const InvestmentTopic = Object.freeze({
    NO_THEME: 'NO_THEME',
    TECH_PROGRESS: 'TECH_PROGRESS',
    DIVIDENDS: 'DIVIDENDS',
    ENERGY_TRANSITION: 'ENERGY_TRANSITION',
});

export const OtherInvestments = Object.freeze({
    NO: 'NO',
    YES: 'YES',
});

export const DetailsFilterType = Object.freeze({
    ASSET_CLASS: 'ASSET_CLASS',
    REGION: 'REGION',
    CURRENCY: 'CURRENCY',
});

export const DetailsSubFilterType = Object.freeze({
    LIQUIDITY: {
        name: 'LIQUIDITY',
        order: 1,
    },
    BONDS: {
        name: 'BONDS', // Obligationen
        order: 2,
    },
    SHARES: {
        name: 'SHARES', // Aktien
        order: 3,
    },
    OTHER_ASSET: {
        name: 'OTHER_ASSET', // Übrige Anlagen
        order: 4,
    },
    SWITZERLAND: {
        name: 'SWITZERLAND',
        order: 1,
    },
    EUROPE: {
        name: 'EUROPE',
        order: 2,
    },
    NORTH_AMERICA: {
        name: 'NORTH_AMERICA',
        order: 3,
    },
    OTHER_REGION: {
        name: 'OTHER_REGION',
        order: 4,
    },
    CHF: {
        name: 'CHF',
        order: 1,
    },
    EUR: {
        name: 'EUR',
        order: 2,
    },
    USD: {
        name: 'USD',
        order: 3,
    },
    OTHER_CURRENCY: {
        name: 'OTHER_CURRENCY',
        order: 4,
    },
});

export const Language = Object.freeze({
    DE: 'DE',
    FR: 'FR',
    IT: 'IT',
});

export const RiskToleranceAnswer = Object.freeze({
    NOT_ANSWERED: 'NOT_ANSWERED',
    ANSWER_1: 'ANSWER_1',
    ANSWER_2: 'ANSWER_2',
    ANSWER_3: 'ANSWER_3',
    ANSWER_4: 'ANSWER_4',
});
